import React, { useEffect, useState } from "react";
import { existUnread, existNewRequest } from '../../Services/Inbox.js';
import "./Nav.css"


import HomeIcon from '../../assets/iconos/home.svg'
import CalendarIcon from '../../assets/iconos/calendar.svg'
import CoursesIcon from '../../assets/iconos/courses.svg'
import BuzonIcon from '../../assets/iconos/bandeja.svg'
import HelpIcon from '../../assets/iconos/help.svg'
import BurguerMenu from '../../assets/iconos/burguermenu.svg'
import BuzonExist from '../../assets/iconos/correoCerrado.svg';
import Contacts from '../../assets/iconos/contactos.svg';
import ContactsNot from '../../assets/iconos/contactosNoti.svg';

const Sidebar = (props) => {


    const [unread, setUnread] = useState(false);
    const [newRequest, setNewRequest] = useState(false);



    const getIsRead = async () => {

        let rsp = await existUnread();

        if (rsp?.Error === false) {
            setUnread(rsp.Data);
        }
    }

    const getIsNewReqeust = async () => {
        let rsp = await existNewRequest();


        if (rsp?.Error === false) {
            setNewRequest(rsp.Data);
        }
    }

    useEffect(() => {
        getIsRead();
        getIsNewReqeust();
    }, []);


    const expanded = props.sidebarState === 0;

    return (
        <div className="sidebar-container" >
            <div className={expanded ? "chevron-burguer-close" : props.sidebarState === 1 ? "chevron-burguer" : "chevron-burguer"} onClick={props.changeSidebarState}>
                <img id="burger" src={BurguerMenu} alt="burguer-menu" className="burguer-icon" />
            </div>
            <div className={expanded ? "sidebar-icons" : props.sidebarState === 1 ? 'sidebar-closed' : 'sidebar-hidden'}>
                <div className="sidebar-icons-container">
                    <a onClick={e => props.setActualFrame('home')} className={props.actualFrame === 'home' ? "icon-container-active" : "icon-container setpointer"} >
                        <img src={HomeIcon} alt="Home" className='icon-sb' />
                        <div className="icon-label">
                            <p className="icon-text">Inicio</p>
                            {expanded && <p className="icon-desc">Novedades y actividad reciente</p>}
                        </div>
                    </a>
                    <a onClick={e => props.setActualFrame('calendar')} className={props.actualFrame === 'calendar' ? "icon-container-active" : "icon-container setpointer"}>
                        <img src={CalendarIcon} alt="Calendar" className='icon-sb' />
                        <div className="icon-label">
                            <p className="icon-text">Calendario</p>
                            {expanded && <p className="icon-desc">Eventos y fechas importantes</p>}
                        </div>
                    </a>
                    <a onClick={e => props.setActualFrame('cursadas')} className={props.actualFrame === 'cursadas' ? "icon-container-active" : "icon-container setpointer"}>
                        <img src={CoursesIcon} alt="Courses" className='icon-sb' />
                        <div className="icon-label">
                            <p className="icon-text">Cursadas</p>
                            {expanded && <p className="icon-desc">Mis cursos activos</p>}
                        </div>
                    </a>
                    <a onClick={e => { props.setActualFrame('buzon'); setUnread(false) }} className={props.actualFrame === 'buzon' ? "icon-container-active" : "icon-container setpointer"}>
                        <img src={!unread ? BuzonIcon : BuzonExist} alt="Buzon" className='icon-sb' />
                        <div className="icon-label">
                            <p className="icon-text">Buzón{unread && <span className="sb-badge"/>}</p>
                            {expanded && <p className="icon-desc">Mensajes recibidos</p>}
                        </div>
                    </a>
                    <a onClick={e => { props.setActualFrame('contactos'); setNewRequest(false);}} className={props.actualFrame === 'contactos' ? "icon-container-active" : "icon-container setpointer"}>
                        <img src={!newRequest ? Contacts : ContactsNot} alt="Contactos" className='icon-sb' />
                        <div className="icon-label">
                            <p className="icon-text">Contactos{newRequest && <span className="sb-badge"/>}</p>
                            {expanded && <p className="icon-desc">Red y solicitudes</p>}
                        </div>
                    </a>
                    <a onClick={e => props.setActualFrame('ayuda')} className={props.actualFrame === 'ayuda' ? "icon-container-active" : "icon-container setpointer"}>
                        <img src={HelpIcon} alt="Help" className='icon-sb'/>
                        <div className="icon-label">
                            <p className="icon-text">Ayuda</p>
                            {expanded && <p className="icon-desc">Preguntas frecuentes y soporte</p>}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}




export default Sidebar